import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: { defaultMessage: 'Liquidation penalty' },
  description: {
    defaultMessage:
      'When a liquidation occurs, liquidators repay part or all of the outstanding borrowed amount on behalf of the borrower. In return, they can buy the collateral at a discount and keep the difference as a bonus!',
  },
});
